import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import PhoneInput from "../Common/PhoneInput";

class WithFacebookForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      eyeOff: true
    };
  }

  handlePasswordVisibility = event => {
    event.preventDefault();
    const { eyeOff } = this.state;
    this.setState({ eyeOff: !eyeOff });
  };
  render() {
    const {
      onChange,
      handleSubmit,
      onCloseSection,
      emailRequired,
      formErrors,
      showErrors,
      submitPhoneNumber,
      active
    } = this.props;
    const { eyeOff } = this.state;
    return (
      <div>
        <div className="modal-bg" />
        <div className="modal">
          <div className="sign-page register-page with-facebook">
            <div className="head-general with-back">
              <a href="javascript: void(0)" className="visibiliy-hidden">
                &nbsp;
              </a>
              <h4>SIGN IN WITH FACEBOOK</h4>
              <a
                href="javascript: void(0)"
                onClick={onCloseSection}
                className="close"
              >
                <i className="icon icon-close" />
              </a>
            </div>
            {/* Header */}
            <div className="modal-body">
              <div className="row">
                <div className="col-sm-6">
                  <form onSubmit={handleSubmit}>
                    {(!emailRequired && <noscript />) || (
                      <div
                        className={`form-group ${(showErrors &&
                          formErrors &&
                          formErrors["email"] &&
                          "error") ||
                          ""}`}
                      >
                        <input
                          id="email"
                          className="form-input"
                          type="email"
                          autoComplete="email"
                          autoCapitalize="none"
                          placeholder="Email"
                          onChange={e => onChange(e)}
                        />
                        <span>
                          {(showErrors &&
                            formErrors &&
                            formErrors["email"] &&
                            formErrors["email"]) ||
                            ""}
                        </span>
                      </div>
                    )}
                    <div
                      className={`form-group ${(showErrors &&
                        formErrors &&
                        formErrors["password"] &&
                        "error") ||
                        ""}`}
                    >
                      <input
                        id="password"
                        className="form-input"
                        autoCapitalize="none"
                        autoComplete="password"
                        type={eyeOff ? "password" : "text"}
                        placeholder="Password"
                        onChange={e => onChange(e)}
                      />
                      <i
                        onClick={e => this.handlePasswordVisibility(e)}
                        className={
                          eyeOff ? "icon icon-eye-off" : "icon icon-eye-on"
                        }
                      />
                      <span>
                        {(showErrors &&
                          formErrors &&
                          formErrors["password"] &&
                          formErrors["password"]) ||
                          ""}
                      </span>
                    </div>
                    <PhoneInput
                      showErrors={showErrors}
                      submitPhoneNumber={submitPhoneNumber}
                    />
                    <p className="small">
                      We use your phone number and e-mail address to send you
                      order details and receipts
                    </p>
                    <p className="small">
                      We use your phone number and e-mail address to send you
                      order details and receipts
                    </p>
                    <div className="login-foot">
                      <div className="pt visible-xs">
                        <p>Already have an account?</p>
                        <a href="javascript: void(0)" onClick={onCloseSection}>
                          Sign in!
                        </a>
                      </div>
                      <p>
                        By signing into your account or joining you agree to
                        our&nbsp;&nbsp;
                        <a href="/terms">Terms and Conditions</a>
                        &nbsp;and&nbsp;
                        <a href="/privacy">Privacy Policy</a>
                      </p>
                    </div>
                    <div className="">
                      <button
                        className={`btn btn-sign login-button fixed-btn ${(active &&
                          "active") ||
                          ""}`}
                        type="submit"
                      >
                        <span>Submit</span>
                      </button>
                    </div>
                  </form>
                </div>
                {/* .col-sm-6 */}

                <div className="col-sm-6 hide-xs">
                  <div className="desktop-gray-side">
                    <p>
                      Already have an account?
                      <br />
                      <a href="javascript: void(0)" onClick={onCloseSection}>
                        Sign in!
                      </a>
                    </p>
                  </div>
                </div>
                {/* .col-sm-6 */}
              </div>
              {/* .row */}
            </div>{" "}
            {/* .modal-body */}
          </div>{" "}
          {/* .sign-page */}
        </div>{" "}
        {/* .modal */}
      </div>
    );
  }
}

export default withRouter(WithFacebookForm);
